import React from "react";
import { Table, Popover } from "antd";
import { useEffect, useState } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { formatDateTime } from "../../helpers/date";
import { usePermissions } from "../App/PermissionContext";
import { BeneficiaryRequestStatusTag } from "../shared/payoutTag";

const BeneficiaryRequestList = (props) => {
  const { permissions } = usePermissions();

  const [requests, setRequests] = useState(props.requests);

  useEffect(() => {
    setRequests(props.requests);
  }, [props.requests]);

  const table = [
    {
      title: "Merchant Id",
      dataIndex: ["merchant", "objectId"],
      width: 100,
      ellipsis: true,
    },
    {
      title: "GUID",
      dataIndex: "beneficiaryGUID",
      width: 100,
      render: (_, record) => {
        return <span>{record.beneficiaryGUID || "-"}</span>;
      },
    },
    {
      title: "Request Created Date",
      dataIndex: "createdAt",
      width: 100,
      render: (createdAt) => formatDateTime(createdAt),
    },
    {
      title: "Beneficiary Merchant",
      dataIndex: ["merchant", "beneficiary"],
      width: 150,
      render: (_, record) => {
        const requestData = record.merchant.beneficiary || {};
        const phone = requestData.beneficiaryMobileId || "";
        const email = requestData.beneficiaryEmail || "";

        return (
          <>
            {phone || "-"} ({email || "-"})
          </>
        );
      },
    },
    {
      title: "Beneficiary Details",
      dataIndex: ["data"], // just beneficiary object
      width: 100,
      render: (_, record) => {
        const requestData = record.data || {};
        const bankName = requestData.bankName || "-";
        const accountNo = requestData.bankAccount || "";
        const accName = requestData.bankHolderName || "";
        const docType = requestData.docType || "-";
        const BRN = requestData.BRN || "-";

        const bankDetails = (
          <p style={{ margin: 0 }}>
            <strong>Bank</strong>: {bankName} <br />
            <strong>Bank Account</strong>: {accountNo} <br />
            <strong>Account Name</strong>: {accName} <br />
            <strong>Doc Type</strong>: {docType} <br />
            <strong>BRN</strong>: {BRN} <br />
          </p>
        );

        return bankDetails;
      },
    },
    {
      title: "Status",
      dataIndex: ["status"],
      width: 50,
      render: (status) => <BeneficiaryRequestStatusTag statusKey={status} />,
    },
    {
      title: "Reject Reason",
      dataIndex: ["reason"],
      width: 100,
      render: (reason) => reason || "-",
    },
  ];

  return (
    <div className="table mt-2">
      <Table
        rowKey="userId"
        className="table-section"
        columns={table}
        dataSource={requests}
        pagination={false}
        scroll={{ y: 600 }}
        loading={props.loading}
      />
    </div>
  );
};

export default BeneficiaryRequestList;
